import React from "react";
import { DownloadButton } from "../DownloadButton";
import { Container, ContainerFW } from "../global";
export const DownloadButtonDeck = ({ title, buttons }) => (React.createElement(ContainerFW, { backgroundColor: "#fff" },
    React.createElement(Container, null,
        React.createElement("div", { className: "download-button-deck" },
            React.createElement("h3", { className: "h3-bold" }, title),
            React.createElement("div", { className: "download-button-deck__container" }, buttons.map(button => React.createElement(DownloadButton, { key: `${button.label.replace(/\s+/g, "")}`, ...button })))))));
